// extracted by mini-css-extract-plugin
module.exports = {"InventoryAlerts__table":"InventoryAlerts_InventoryAlerts__table__3NjNp"};